import UploadReducer from "../reducers/UploadReducer";
import BaseAction from "./BaseAction";

class UploadAction extends BaseAction {
  setLoadingImages = async (value) =>
    await this.dispatch({ loadingImages: value });
}

const action = new UploadAction(UploadReducer);

export default action;
